import { render } from "./ProjectsHead.vue?vue&type=template&id=c8a38612"
import script from "./ProjectsHead.vue?vue&type=script&lang=js"
export * from "./ProjectsHead.vue?vue&type=script&lang=js"

import "./ProjectsHead.vue?vue&type=style&index=0&id=c8a38612&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__